module.exports = __webpack_public_path__ + "static/media/small-smart-logo.352b5480.png";